/**
 * Regexp that matches email address structure.
 * Taken from the HTML5 standard
 * https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
 *
 * Note: We disable security/detect-unsafe-regex as https://github.com/davisjam/safe-regex detects this to have catastrophic backtracking
 * as a false positive, but this pattern uses negative lookahead and requires certain characters, e.g. `-` before the pattern is repeated,
 * i.e. `[a-z0-9A-Z-]` followed by `[a-z0-9A-Z]`, to limit the catastrophic backtracking.
 *
 * Here is a version of the same regex that does have a catastrophic backtracking triggered by `somethingverylong@hereandthereseemore-.com`:
 * /^[--9^-~A-Z!#-'*+=?]+@(?:[a-z0-9A-Z-]{0,61}[a-z0-9A-Z]|)([\.]?[a-z0-9A-Z]+)*(?:[a-z0-9A-Z-]{0,61}[a-z0-9A-Z]|)*$/
 *
 * Here is a good example of this: https://stackoverflow.com/a/42692131/1008519
 *
 * See the tests in spec/frontend/forms/validation/rules/valid_email_spec.js for more information on this.
 */
const URI_MAIL_TO_EMAIL_REGEXP =
  // eslint-disable-next-line security/detect-unsafe-regex
  /^[--9^-~A-Z!#-'*+=?]+@[a-z0-9A-Z](?:[a-z0-9A-Z-]{0,61}[a-z0-9A-Z]|)(?:\.[a-z0-9A-Z](?:[a-z0-9A-Z-]{0,61}[a-z0-9A-Z]|))*$/;

function isValidEmail(value) {
  return URI_MAIL_TO_EMAIL_REGEXP.test(value);
}

export const validEmail = {
  validate: (value) => isValidEmail(value),
  message: `Please enter a valid email address.`,
};
